import { shallowEqual, useAppSelector } from 'hooks/reduxHooks'
import { getShouldWaiveLuxPlusJoiningFee } from 'selectors/userCart'
import { useUserCartItemState } from './useUserCartItemState'

type JoiningFeeData = {
  amount: number
  waived: boolean
}

type UserCartSubscriptionItemData = {
  loaded: true
  loading: false
  error: undefined
  subscriptionPrice: number
  joiningFee: JoiningFeeData
  itemTotals: App.Checkout.ItemViewTotals
  isDeleted: boolean
  isSavedForLater: boolean
} | {
  loaded: false
  loading: boolean
  error: any
  subscriptionPrice: number | undefined
  joiningFee: JoiningFeeData | undefined
  itemTotals: App.Checkout.ItemViewTotals | undefined
  isDeleted: boolean
  isSavedForLater: boolean
}

function useUserCartSubscriptionItemData(item: App.Checkout.LuxPlusSubscriptionItem): UserCartSubscriptionItemData {
  const {
    offers,
    loading,
    error,
    waiveJoiningFee,
  } = useAppSelector(state => ({
    offers: state.luxPlus.products.subscription.offers,
    loading: state.luxPlus.products.subscription.fetching,
    error: state.luxPlus.products.subscription.error,
    waiveJoiningFee: getShouldWaiveLuxPlusJoiningFee(state),
  }), shallowEqual)

  const offer = offers?.find(o => o.joinFeeWaived === waiveJoiningFee)
  const { deleted, saveForLater } = useUserCartItemState(item.itemId)

  if (offer) {
    const itemTotals: App.Checkout.ItemViewTotals = {
      price: offer.price,
      memberPrice: 0,
      value: offer.price + offer.joinFee,
      taxesAndFees: 0,
      surcharge: 0,
      memberValue: 0,
      extraGuestSurcharge: 0,
    }

    return {
      loaded: true,
      loading: false,
      error: undefined,
      subscriptionPrice: item.amount,
      joiningFee: {
        amount: offer.joinFee,
        waived: waiveJoiningFee,
      },
      itemTotals,
      isDeleted: deleted,
      isSavedForLater: saveForLater,
    }
  }

  return {
    loaded: false,
    loading,
    error,
    subscriptionPrice: undefined,
    joiningFee: undefined,
    itemTotals: undefined,
    isDeleted: deleted,
    isSavedForLater: saveForLater,
  }
}

export default useUserCartSubscriptionItemData
